var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"platform"},[_c('div',{staticClass:"platform__title"},[_vm._v(_vm._s(_vm.$t('myLearningPlatform')))]),_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }